import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { DictionaryCountryResponse } from '@web/shared/module/dictionary';
import { Guid } from '@web/utils';
import { AdminPaymentMethodResponse } from './admin-payment-method.response';

@jsonObject
export class AdminShippingMethodPriceResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(DictionaryCountryResponse)
  public readonly country!: DictionaryCountryResponse;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonArrayMember(AdminPaymentMethodResponse)
  public readonly paymentMethods!: AdminPaymentMethodResponse[];
}
